import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./slice/authSlice";
import authService from "./service/auth";
import classicService from "./service/classic";
import publicService from "./service/public";
import { topupService } from "./service/topup";
import { missionService } from "./service/mission";
import { subscriberService } from "./service/subscriber";
import feedbackService from "./service/feedback";

const store = configureStore({
  reducer: {
    auth: authReducer,
    [authService.reducerPath]: authService.reducer,
    [classicService.reducerPath]: classicService.reducer,
    [publicService.reducerPath]: publicService.reducer,
    [topupService.reducerPath]: topupService.reducer,
    [missionService.reducerPath]: missionService.reducer,
    [subscriberService.reducerPath]: subscriberService.reducer,
    [feedbackService.reducerPath]: feedbackService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authService.middleware)
      .concat(classicService.middleware)
      .concat(publicService.middleware)
      .concat(topupService.middleware)
      .concat(missionService.middleware)
      .concat(subscriberService.middleware)
      .concat(feedbackService.middleware),
});

setupListeners(store.dispatch);

export default store;
